import { ServiceCall } from '../../state/models';
import { post, postMultiPart } from '../../utils/api';
import { ServiceCallEdit } from './models';

const apiEndpoint = '/api/service-calls';

export async function create(data: ServiceCallEdit): Promise<ServiceCall> {
    return postMultiPart<ServiceCall>(`${apiEndpoint}`, data);
}